

<template>
  <div class="spec-preview">
     <div class="title">
        {{DataSatImg.productName}}
     </div>
    <img :src="`${GLOBAL.imageUrl}${DataSatImg.image}`" height="160px" alt />
    <div class="event" @mousemove="handler"></div>
    <div class="big">
      <img :src="`${GLOBAL.imageUrl}${DataSatImg.image}`" ref="big" alt />
    </div>
    <!-- 遮罩层 -->
    <div class="mask" ref="mask"></div>
  </div>
</template>

<script>
export default {
  name: "Zoom",
  //   props: ["skuImageList"],
  props: ["DataSatImg"],
  data() {
    return {
      currentIndex: 0,
    };
  },
  computed: {
    ImageList() {
      return this.skuImageList[this.currentIndex] || {};
    },
  },
  mounted() {
    //全局事件总线获取兄弟组件传递过来的索引值
    this.$bus.$on("getIndex", (index) => {
      this.currentIndex = index;
    });
  },
  methods: {
    //这里是放大方法的主要处理逻辑
    handler(event) {
      let mask = this.$refs.mask;
      let big = this.$refs.big;
      let left = event.offsetX - mask.offsetWidth / 2;
      let top = event.offsetY - mask.offsetHeight / 2;
      //约束范围
      if (left <= 0) left = 0;
      if (left >= mask.offsetWidth) left = mask.offsetWidth;
      if (top <= 0) top = 0;
      if (top >= mask.offsetHeight) top = mask.offsetHeight;
      mask.style.left = left + "px";
      mask.style.top = top + "px";
      big.style.left = -2 * left + "px";
      big.style.top = -2 * top + "px";
    },
  },
};
</script>

<style lang="scss">
.spec-preview {
  position: relative;
  //   width: 400px;
  //   height: 400px;
  border: 1px solid #f8f8f8;
  border-radius: 2px;
    .title{
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(255,255,255,.7);
        color: #0078d4;
        // background: rgba(0,0,0,0.8);
        font-size: 14px;
        padding:4px 10px;
    }
  img {
    width: 100%;
    height: 180px;
    // object-fit: cover;
  }

  .event {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 998;
  }

  .mask {
    width: 50%;
    height: 50%;
    background-color: rgba(171, 250, 171, 0.3);
    position: absolute;
    left: 0;
    top: 0;
    display: none;
  }

  .big {
    width: 130%;
    height: 130%;
    position: absolute;
    top: -1px;
    right: 100%;
    margin-right: 10px;
    border-radius: 2px;
    border: 1px solid #eeeded;
    overflow: hidden;
    z-index: 998;
    display: none;
    background: white;
    box-shadow: 2px 2px 7px rgb(235, 234, 234);

    img {
      width: 200%;
      max-width: 200%;
      height: 200%;
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  .event:hover ~ .mask,
  .event:hover ~ .big {
    display: block;
  }
}
</style>

